export const officeRateLimitsKeys = {
  member: (identityId) => ['office-rate-limits', identityId],
};
